const telecomandi = {
    "ROGER": {
        "Diretto": "R80-104-R / R80-102-R / H80 / E80 / E80 4 Pulsanti / M80-44-R / Synus (Codice Fisso) / T80-TX2 (Codice Fisso)"
    },
    "APERIO": {
        "Diretto": "GO / GO MINI / GO PRO"
    },
    "CLEMSA": {
        "Diretto": "MASTERCODE MW (CODICE FISSO)",
        "Ricevente": "E-CODE N / MUTANCODE"
    },
    "FAAC": {
        "Diretto": "TML 433SLH / DL 868 SLH / T 433 SLH / T 868 SLH / XT 433 SLH / XT 868 SLH / XT 433 SLH BLACK / XT 868 SLH BLACK",
        "Autoapprendimento": "TE433HG / XT 433 RC / XT4 433 RCBE"
    },
    "GENIUS": {
        "Diretto": "AMIGO / AMIGOLD / KILO",
        "Autoapprendimento": "BRAVO / ECHO"
    },
    "NORTON": {
        "Diretto": "GO MINI NORTON / GO NORTON",
        "Autoapprendimento": "NEO / TXCD"
    },
    "ROPER": {
        "Diretto": "GO MINI ROPER / GO ROPER",
        "Autoapprendimento": "NEO"
    },
    "ADYX": {
        "Autoapprendimento": "433-HG BRAVO / TE4433H BLUE"
    },
    "AERF": {
        "Autoapprendimento": "COMPACT / HY-DOM / MARS / MERCURI B / MERCURI C / SABUTON / SATURN / ST3/N / TERRA / TMP-1 / TMP-2 / UNITECH"
    },
    "ALLMATIC": {
        "Autoapprendimento": "BRO.OVER / BROWN / BROWN RED / MINIPASS / PASS / TECH3"
    },
    "APRIMATIC": {
        "Autoapprendimento": "TR / TM4 / TXM"
    },
    "BENINCA": {
        "Autoapprendimento": "APPLE / CUPIDO / LOT WCV / ROLLKEY / TO.GO.WV / TO.GO.QV / TWV",
        "Ricevente": "IO"
    },
    "BFT": {
        "Autoapprendimento": "GHIBLI / KLEIO / MITTO / MITTO A / MITTO M / MITTO RCB / MURALE / TRC"
    },
    "CARDIN": {
        "Autoapprendimento": "XRADO / S437 TX / TRQ S449 / TRQ S449 GREEN (PRECODE) / TRQ S486 / TXQ S449 / TXQ S449 GREEN / TXQ S486"
    },
    "CAME": {
        "Diretto": "TOP 432 EE / TOP 434 EE / TOP 862 EE",
        "Autoapprendimento": "TOP 2DR / TOP 4DR"
    },
    "DITEC": {
        "Autoapprendimento": "BIXLG / BIXLP / GOL4"
    },
    "ERREKA": {
        "Autoapprendimento": "IRIS / ROLLER 2 / ROLLER 433 / ROLLER 868 / SOL 433 / SOL 868 / VEGA 433 / VEGA 868"
    },
    "FADINI": {
        "Autoapprendimento": "JUBI433 / JUBI-SMALL"
    },
    "GIBIDI": {
        "Autoapprendimento": "AU1600 / AU1600 WOOD / AU1680 / AU1680 WOOD / DOMINO"
    },
    "JCM": {
        "Autoapprendimento": "NEO / TWIN"
    },
    "KING GATES": {
        "Autoapprendimento": "CLIPPER / STYLO"
    },
    "MHOUSE": {
        "Autoapprendimento": "GTX4 / TX3 / TX4"
    },
    "MOOVO": {
        "Autoapprendimento": "MT4G"
    },
    "NICE": {
        "Autoapprendimento": "ERGO / FLOR-S / FLOR-S ERA / INTI / PLANO / SMILO / VERY-VR / ON ERA / ONE (ON) / ONE (ON FM)"
    },
    "O&O": {
        "Autoapprendimento": "T.COM R4-2 / T.COM R8-2 / TX / TX (NEO) / TWIN"
    },
    "PRASTEL": {
        "Autoapprendimento": "BFOR / MPSTLE  /  MPSTP2E / MTE / SLIM-E / TCE / TRQ-P"
    },
    "SABUTOM": {
        "Autoapprendimento": "BROOVER / BROSTAR"
    },
    "SECULUX": {
        "Autoapprendimento": "NEO"
    },
    "SIMINOR": {
        "Autoapprendimento": "CVXNL / MITTO",
        "Ricevente": "SIM433"
    },
    "TAU": {
        "Autoapprendimento": "250K-SLIMR / 250K-SLIMRP / 250T-4RP"
    },
    "V2": {
        "Autoapprendimento": "HANDY / PHOENIX / PHOX 433 / TRC / TSC / TXC"
    },
    "VDS": {
        "Autoapprendimento": "ECO-R / TRQ P"
    },
    "ACM": {
        "Ricevente": "TX2 / TX2 COLOR / TX4"
    },
    "APERTO (SOMMER)": {
        "Ricevente": "4020-TX03-434 / TX02-434-2 / TX02-868-2"
    },
    "ATA": {
        "Ricevente": "PTX4 BLU / PTX4 PINK"
    },
    "AVIDSEN": {
        "Ricevente": "104250 / 104250 OLD / 104250 RED / 104251 / 104257 / 104350 / 654250"
    },
    "BALLAN": {
        "Ricevente": "FM400 / FM400E"
    },
    "CASALI": {
        "Ricevente": "GENIUS / CASALI A252RC"
    },
    "CHAMBERLAIN LIFT MASTER MOTOR LIFT": {
        "Ricevente": "953ESTD / 371 LM / 971 LM / 84330E / 94334CE / 94333E / 94334E / 94335E / 9747E / 1A5639-7 / 1A5477 / 1A6487 / 132B2372 / 94330EML / 9333EML / 94335EML / 84330EML / 84333EML / 84335EML / 8747EML"
    },
    "DASPI": {
        "Ricevente": "ZERO RC"
    },
    "DEA SYSTEM": {
        "Ricevente": "GENIE R 273 / GENIE R-GT2N / GOLDR / GT2M / MIO TR / PUNTO 278 / TRN"
    },
    "DOORHAN": {
        "Ricevente": "TRANSMITTER 4"
    },
    "DOORMATIC": {
        "Ricevente": "MILENY / MILENY-EVO"
    },
    "ECOSTAR": {
        "Ricevente": "RSC / RSE / RSZ"
    },
    "GENIE": {
        "Ricevente": "G1T-BX / G3T-BX / GICT390 / GICTD / GIFT390-1 / GIFTD / GIT / GITR-3 / GM3T"
    },
    "KBLUE": {
        "Ricevente": "ETH-TEL01"
    },
    "KEY": {
        "Ricevente": "900TXB-42R / SUB 44R / TXB 44R"
    },
    "KLING": {
        "Ricevente": "KUA / KUA E / KUA S"
    },
    "LABEL": {
        "Ricevente": "SPYCO"
    },
    "LIFE": {
        "Ricevente": "FIDO"
    },
    "LINEAR": {
        "Ricevente": "ACT-21 / ACT-22 / MCT-11 / STING RAY ACT-31 / STING RAY ACT-34B"
    },
    "MERLIN 2.0": {
        "Ricevente": "E940M / E943M / E945M"
    },
    "MERLIN PROLIFT": {
        "Ricevente": "C940 / C943 / C945 / M842 / M844"
    },
    "NOVOFERM": {
        "Ricevente": "MCHS / MICRO-NOVOTRON 502 / MINI-NOVOTRON 504 / MICRO-NOVOTRON 502 / MICRO-NOVOTRON 504 / MICRO-NOVOTRON 31 / MICRO-NOVOTRON 51 / MINI-NOVOTRON 30 / MINI-NOVOTRON 50 / MNHS"
    },
    "PECCININ": {
        "Ricevente": "TX MENBRANA"
    },
    "PUJOL": {
        "Ricevente": "TWIN / VARIO / VARIO MARS / VARIO OCEAN / NEO"
    },
    "RIB": {
        "Ricevente": "LITHIO"
    },
    "SEA": {
        "Ricevente": "COCCINELLA ROLL / HEAD / SMART-3 ROLLING CODE / SMART DUAL ROLL"
    },
    "SEAV": {
        "Ricevente": "BE HAPPY RS"
    },
    "SILVELOX": {
        "Ricevente": "MHZ 2007 / QUARZ SAW"
    },
    "SOMFY": {
        "Ricevente": "K-EASY / K-EASY NEW / K-EASY OLD / MITTO / KEY GO RTS / TELIS RTS / KEYTIS RTS / KEYTIS RTS NS / ALARMA"
    },
    "SOMMER": {
        "Ricevente": "4010 / 4011 / 4014 TX03-434-2 / 4013 TX03-434-4 / 4020 TX03-868-4 / 4026 TX03-868-2 / 4022 TX02-434-2 / 4025 TX02-868-2 / 4031 TX08-868-4"
    },
    "STAGNOLI": {
        "Ricevente": "KALLISTO / VENUS AV223"
    },
    "TELCOMA": {
        "Ricevente": "FM400 / FM400E"
    },
    "TOR LIFT": {
        "Ricevente": "TORMIT4"
    }
}

const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}

const marchi = ['ACM', 'ADYX', 'AERF', 'ALLMATIC', 'APERIO', 'APERTO (SOMMER)', 'APRIMATIC', 'ATA', 'AVIDSEN', 'BALLAN', 'BENINCA', 'BFT', 'CARDIN', 'CASALI', 'CAME', 'CHAMBERLAIN LIFT MASTER MOTOR LIFT', 'CLEMSA', 'DASPI', 'DEA SYSTEM', 'DITEC', 'DOORHAN', 'DOORMATIC', 'ECOSTAR', 'ERREKA', 'FAAC', 'FADINI', 'GENIE', 'GENIUS', 'GIBIDI', 'JCM', 'KBLUE', 'KEY', 'KING GATES', 'KLING', 'LABEL', 'LIFE', 'LINEAR', 'MERLIN 2.0', 'MERLIN PROLIFT', 'MHOUSE', 'MOOVO', 'NICE', 'NORTON', 'NOVOFERM', 'O&O', 'PECCININ', 'PRASTEL', 'PUJOL', 'RIB', 'ROGER', 'ROPER', 'SABUTOM', 'SEA', 'SEAV', 'SECULUX', 'SILVELOX', 'SIMINOR', 'SOMFY', 'SOMMER', 'STAGNOLI', 'TAU', 'TELCOMA', 'TOR LIFT', 'V2', 'VDS'];

export function getMarchi() {
    return marchi
}

export function getMarchiForDropdown() {
    var to_return = [];
    for (var marca in marchi.sort()) {
        to_return.push({ value: marchi[marca], label: capitalize(marchi[marca]) })
    }
    return to_return.sort()
}

function cleanTitle(telecomando) {
    var to_ret = telecomando.replace("_diretto", "")
    to_ret = to_ret.replace("_autoapprendimento", "")
    to_ret = to_ret.replace("_ricevente", "")

    return to_ret
}

export function getModelliForDropdown(marca) {
    var to_return = []
    for (var element in telecomandi[marca]) {
        console.log(element)
        if (element === "Diretto") {
            for (var remote in telecomandi[marca]["Diretto"].split("/")) {
                to_return.push(telecomandi[marca]["Diretto"].split("/")[remote] + "_diretto")
            }
        }
        else if (element === "Autoapprendimento") {
            for (remote in telecomandi[marca]["Autoapprendimento"].split("/")) {
                to_return.push(telecomandi[marca]["Autoapprendimento"].split("/")[remote] + "_autoapprendimento")
            }
        } else if (element === "Ricevente") {
            for (remote in telecomandi[marca]["Ricevente"].split("/")) {
                to_return.push(telecomandi[marca]["Ricevente"].split("/")[remote] + "_ricevente")
            }
        }
    }

    console.log(to_return)

    var to_return_array = []

    for (var index in to_return) {
        to_return_array.push({ value: to_return[index], label: cleanTitle(to_return[index]) })
    }

    to_return_array.sort()

    console.log(to_return_array)

    return to_return_array
}

export function getDetailsForModello() {

}